import React from 'react';
import { Linkedin, Twitter, Mail } from 'lucide-react';
import { motion } from 'framer-motion';
const team = [{
  name: 'Elizepher W. Maroa',
  role: 'Founder & Strategic Comms Lead',
  bio: 'Strategic Communications & Media Specialist with 5+ years of experience crafting compelling narratives and building impactful brand strategies.',
  initials: 'EM',
  image: 'https://cdn.magicpatterns.com/uploads/4AaLupKUP7Q82YtDaxR12z/Elizepher_Maroa.jpg'
}, {
  name: 'Luther Osier',
  role: 'Lead Strategy',
  bio: 'Seasoned marketing strategist with a deep understanding of African markets. Translates business objectives into actionable, performance-driven strategies.',
  initials: 'LO',
  image: 'https://cdn.magicpatterns.com/uploads/tVJMvchLLBLBQQsTzoGbqH/Luther_Osier.jpg'
}, {
  name: 'Nancy Lugose',
  role: 'Finance & Legal Lead',
  bio: 'Experienced finance and legal professional leading financial planning, compliance, and risk mitigation to enable sustainable growth across African markets.',
  initials: 'NL',
  image: 'https://cdn.magicpatterns.com/uploads/ei9LVNn9PfHvJjy5F4vLTr/Nancy_Lugose.jpg'
}, {
  name: 'Nellyvine Nekesa',
  role: 'Project Manager / Events',
  bio: 'Expert in planning and delivering high-impact events and media productions. Combines creativity with structure for seamless execution.',
  initials: 'NN',
  image: 'https://cdn.magicpatterns.com/uploads/mJjvpnhYqpDqqKb41ES61E/Nellyvine_Nekesa_image.jpg'
}];
export function TeamSection() {
  return <section id="team" className="py-24 bg-white relative scroll-mt-24" data-id="element-143">
      {/* Background Pattern */}
      <div className="absolute top-0 left-0 w-full h-64 bg-[#1B4D3E]" data-id="element-144" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-145">
        <div className="text-center mb-20" data-id="element-146">
          <h2 className="text-[#D4AF37] font-sans font-semibold tracking-[0.2em] uppercase text-sm mb-4" data-id="element-147">
            Our Leadership
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif font-medium text-white mb-6" data-id="element-148">
            Meet the Minds Behind the Magic
          </h3>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto font-light" data-id="element-149">
            A diverse team of strategists, creatives, and leaders dedicated to
            your growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-150">
          {team.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.6
        }} className="group relative bg-white rounded-sm shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden border-t-4 border-[#D4AF37]" data-id="element-151">
              {/* Image Container */}
              <div className="h-80 w-full overflow-hidden relative bg-gray-100" data-id="element-152">
                {member.image ? <img src={member.image} alt={member.name} className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110 grayscale group-hover:grayscale-0" data-id="element-153" /> : <div className="w-full h-full flex items-center justify-center bg-[#1B4D3E]/5" data-id="element-154">
                    <span className="text-6xl font-serif text-[#1B4D3E] opacity-20" data-id="element-155">
                      {member.initials}
                    </span>
                  </div>}
                {/* Overlay Gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#1B4D3E]/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-156" />

                {/* Social Icons Overlay */}
                <div className="absolute bottom-0 left-0 w-full p-6 translate-y-full group-hover:translate-y-0 transition-transform duration-500 flex justify-center space-x-4" data-id="element-157">
                  <a href="#" className="text-white/80 hover:text-[#D4AF37] transition-colors" data-id="element-158">
                    <Linkedin size={20} data-id="element-159" />
                  </a>
                  <a href="#" className="text-white/80 hover:text-[#D4AF37] transition-colors" data-id="element-160">
                    <Twitter size={20} data-id="element-161" />
                  </a>
                  <a href="#" className="text-white/80 hover:text-[#D4AF37] transition-colors" data-id="element-162">
                    <Mail size={20} data-id="element-163" />
                  </a>
                </div>
              </div>

              {/* Content */}
              <div className="p-6 text-center relative bg-white" data-id="element-164">
                <h4 className="text-xl font-serif font-bold text-[#1B4D3E] mb-1" data-id="element-165">
                  {member.name}
                </h4>
                <p className="text-[#D4AF37] text-xs font-bold uppercase tracking-wider mb-4" data-id="element-166">
                  {member.role}
                </p>
                <p className="text-gray-600 text-sm leading-relaxed font-light line-clamp-4" data-id="element-167">
                  {member.bio}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}